import { render, staticRenderFns } from "./ActividadesProyecto.vue?vue&type=template&id=48e12be6"
import script from "./ActividadesProyecto.vue?vue&type=script&lang=js"
export * from "./ActividadesProyecto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports